var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CatalogManager',{attrs:{"type":"categories","title":"Categorías"}})
}
var staticRenderFns = []

export { render, staticRenderFns }